var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"app-timer"},[_c('span',{staticClass:"app-timer--minutes"},[_vm._v(_vm._s(_vm.minutes_left))]),_c('span',{staticClass:"app-timer--divider"},[_vm._v(_vm._s(_vm.divider))]),_c('span',{staticClass:"app-timer--seconds"},[_vm._v(_vm._s(_vm.seconds_left))])])
}
var staticRenderFns = []

export { render, staticRenderFns }